import React, { useState } from "react";
import { Flame } from "lucide-react";
import { TopMadaCard } from "./TopMadaCard";

const LOGO_URL = "/assets/icon.png";

/**
 * Logo keeps its black background which blends with the dark theme.
 * Kept as component for easier evolution (filters, etc.) later.
 */
export const LogoSvgFilter = () => null;

export const MadafricaLogo = ({ size = 56, withText = false, className = "", showTopMadaBadge = true }) => {
  const imgHeight = withText ? size * 2.5 : size;

  return (
    <div className={`relative inline-flex items-center ${className}`} data-testid="voamada-logo">
      <img
        src={LOGO_URL}
        alt="Voamada"
        style={{
          height: imgHeight,
          width: "auto",
          filter: "drop-shadow(0 8px 32px rgba(243,211,94,0.35))",
          WebkitFilter: "drop-shadow(0 8px 32px rgba(243,211,94,0.35))",
        }}
        className="object-contain"
      />
      {showTopMadaBadge && <TopMadaBadge />}
    </div>
  );
};

/**
 * Badge pulsant "by Top Mada" — orange/rouge dégradé.
 * Au clic, ouvre la carte modale Top Mada (stats sociales + liens FB/TikTok).
 */
export const TopMadaBadge = () => {
  const [open, setOpen] = useState(false);

  const openCard = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={openCard}
        data-testid="topmada-badge"
        aria-label="Propulsé par Top Mada — voir le profil"
        className="absolute -bottom-1 -right-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] sm:text-[10px] font-bold uppercase tracking-wider text-white shadow-lg shadow-orange-900/40 ring-1 ring-white/30 whitespace-nowrap select-none hover:scale-105 transition-transform"
        style={{
          background: "linear-gradient(90deg,#ff4d2d 0%,#ff8a00 50%,#ffb627 100%)",
          animation: "topmadaPulse 2.4s ease-in-out infinite",
        }}
      >
        <Flame size={10} className="text-white drop-shadow" />
        <span>by Top Mada</span>
      </button>
      <TopMadaCard open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default MadafricaLogo;
